import { render, staticRenderFns } from "./ModalForSignDocument.vue?vue&type=template&id=bec2a4c6&"
import script from "./ModalForSignDocument.vue?vue&type=script&lang=js&"
export * from "./ModalForSignDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalForSignDocument.vue?vue&type=style&index=0&id=bec2a4c6&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bec2a4c6')) {
      api.createRecord('bec2a4c6', component.options)
    } else {
      api.reload('bec2a4c6', component.options)
    }
    module.hot.accept("./ModalForSignDocument.vue?vue&type=template&id=bec2a4c6&", function () {
      api.rerender('bec2a4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/ModalForSignDocument.vue"
export default component.exports